const PRIVILEGES = {
  VIEW_MESSAGING_AVAILABILITY_INFO: 1740,
  SKILL_CHATS: 9,
  VIEW_AGENT_LIST: 1574,
  VIEW_CAMPAIGN_MODULE: 1500,
  VIEW_USERS_MODULE: 1501,
  VIEW_AGENT_MANAGER_WORKSPACE_PRIVILEGE: 1784,
  VIEW_AGENT_MANAGER_WORKSPACE_PRIVILEGE_NEW: 1791,
  MANAGER_WORKSPACE_CONFIGURATION: 1850,
  VIEW_AGENT_WORKSPACE: 1786,
  VIEW_ACTIVE_CONNECTIONS: 1734,
  VIEW_SKILL_LEVEL_METRICS_MANAGER_WORKSPACE: 1851,
  VIEW_BOTS_WIDGET: 1879,
  CONFIGURE_ALERTS: 1880,
  VIEW_ALERTS: 1881,
};

const FEATURES = {
  MANAGER_WORKSPACE: 'Messaging.ManagerWorkspace',
  MESSAGING: 'Common.Async_Messaging',
  MANAGER_WORKSPACE_CONFIGURATION: 'Messaging.ManagerWorkspaceConfiguration',
  CONTACT_CENTER: 'Common.Messaging_Cross_Account_Contact_Center',
  NEW_AGENT_WORKSPACE: 'Messaging.New_agent_workspace',
  ENFORCE_NEW_AGENT_WORKSPACE: 'LEUI.Enforce_New_Agent_Workspace',
  PORTAL_ACCESS: 'Intelligence.portalAccess',
  PORTAL_ACCESS_LPA_ONLY: 'Intelligence.portalAccessLPAOnly',
  MANAGER_WORKSPACE_SKILLS_VIEW: 'Messaging.ManagerWorkspaceSkillsView',
  SOCIAL_CONNECT: 'SocialConnect.Enabled',
  USER_TYPE_BOT: 'Common.User_type_bot',
  AGENT_VIEW_FOR_AGENTS: 'Messaging.AgentViewForAgentsInMWS',
  VIEW_BOTS_WIDGET_IN_MWS: 'Messaging.ManagerWorkspace_bots_widget',
  MANAGER_WORKSPACE_ALERTS: 'Messaging.ManagerWorkspace_UI_Alerts',
  VIEW_TABS_IN_MWS: 'Messaging.ManagerWorkspace_Tabs_View',
};

const SESSION_SETTINGS = {
  BLOCK_CONSUMER_NAME: 'le.agent.block.visitor.name',
  LOCALE: 'le.general.language',
  HOUR_FORMAT: 'le.agent.hourFormat',
  MANAGER_WORKSPACE_METRICS_CONFIGURATION: 'le.agent.messaging.managerWorkspaceMetricsConfiguration',
  SHOW_NEW_AGENT_WORKSPACE: 'le.agent.messaging.showEnhancedAgentWorkspace',
  NEW_AGENT_WORKSPACE_LPA: 'le.agent.messaging.newAgentWorkspaceForLPA',
};

const MANAGER_WORKSPACE_SITE_SETTINGS_GROUP = 'managerWorkspace';

const SITE_SETTINGS_VERSION_KEY = 'AMW_version';

const DIALOG_TYPES = {
  MAIN: 'MAIN',
  POST_SURVEY: 'POST_SURVEY',
  AGENT: 'AGENT',
  OTHER: 'OTHER',
};

const WIDGET_LOGICAL_NAMES = {
  GLOBAL: 'global',
  IN_QUEUE: 'in_queue',
  SHIFT_STATUS: 'shift_status',
  AGENTS: 'agents',
  CONVERSATIONS: 'conversations',
  SKILLS: 'skills',
  BOTS: 'bots',
};

const WIDGET_PERMISSIONS_MAP = {
  [WIDGET_LOGICAL_NAMES.AGENTS]: [PRIVILEGES.VIEW_AGENT_LIST],
  [WIDGET_LOGICAL_NAMES.SKILLS]: [PRIVILEGES.VIEW_SKILL_LEVEL_METRICS_MANAGER_WORKSPACE],
  [WIDGET_LOGICAL_NAMES.BOTS]: [PRIVILEGES.VIEW_BOTS_WIDGET],
};

const WIDGET_FEATURES_MAP = {
  [WIDGET_LOGICAL_NAMES.SKILLS]: [FEATURES.MANAGER_WORKSPACE_SKILLS_VIEW],
  [WIDGET_LOGICAL_NAMES.BOTS]: [FEATURES.USER_TYPE_BOT, FEATURES.VIEW_BOTS_WIDGET_IN_MWS],
};

export const HOUR_FORMATS = {
  AM_PM: '12',
  24: '24',
};

const RESTART_SUBSCRIPTION_STATUS_CODES = [401, 404, 408, 409, 500, 502, 503, 504, 507];
const THROTTLING_STATUS_CODE = 429;

const RETRY_INTERVAL = 10000;

const AC_RETRY_AFTER_ERROR_INTERVAL = 30000;

const RETRIES_MAX_NUMBER = 3;

const AXIOS_RETRY_OBJECT = 'axios-retry';

const UPDATE_SUBSCRIPTION_MODE = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
};

const AGENT_STATUSES = {
  ONLINE: 'ONLINE',
  BACK_SOON: 'BACK_SOON',
  AWAY: 'AWAY',
  OFFLINE: 'OFFLINE',
};

const AGENT_STATUSES_LABELS_I18N_KEYS = {
  [AGENT_STATUSES.ONLINE]: 'agent_status_online',
  [AGENT_STATUSES.BACK_SOON]: 'agent_status_back_soon',
  [AGENT_STATUSES.AWAY]: 'agent_status_away',
};

const CONVERSATION_STATUSES = {
  IN_QUEUE: 'IN_QUEUE',
  OPEN: 'OPEN',
  CLOSE: 'CLOSE',
};

const CONVERSATION_QUEUE_STATES = {
  ACTIVE: 'ACTIVE',
  IN_QUEUE: 'IN_QUEUE',
};

const CONVERSATION_STATUSES_I18N_KEYS = {
  ALL: 'conversations_column_status_all',
  IN_QUEUE: 'conversations_column_status_in_queue',
  OPEN: 'conversations_column_status_assigned',
  CLOSE: 'conversations_column_status_closed',
};

const CONVERSATION_STATUSES_CLASSES_MAP = {
  IN_QUEUE: 'ico-conversation-status-inqueue',
  OPEN: 'ico-conversation-status-assigned',
  CLOSE: 'ico-conversation-status-close',
};

const DATA_LOADING_STATES = {
  NONE: 'none',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
  WRONG_FORMAT: 'wrong',
  OBSOLETE: 'obsolete', // this state will be ... obsolete. will be removed after implementation in the other error handling widgets
};

const WIDGET_MODES = {
  TABLE: 'table',
  CARDS: 'cards',
  TABLE_AND_GRAPH: 'tableAndGraph',
  CARDS_AND_GRAPH: 'cardsAndGraph',
};

// Each of the "metrics" here represents data that presents in one of the widgets
// (in any of the modes)
const METRIC_NAMES = {
  CLOSED_CONVERSATIONS: 'totalResolvedConversations',
  // RESPONSE_TIME: 'avgTimeResolvedConversations',// Remove response time
  CONVERSATIONS_RESPONSE_TIME: 'responseTime',
  LOAD_CONVERSATIONS: 'weightedAvgLoad',
  AGENT_LOAD_CONVERSATIONS: 'load',
  ASSIGNED_CONVERSATIONS: 'openAssignedConversations',
  CSAT: 'csatScore',
  AGENT_STATUS: 'currentStatus',
  AGENT_STATUS_DURATION: 'currentStatusDuration',
  AGENT_STATUS_REASON_DURATION: 'currentStatusReasonDuration',
  AGENT_STATUS_REASON: 'currentStatusReason',
  AGENT_ID: 'agentId',
  AGENT_NAME: 'agentName',
  ONLINE_RATE: 'onlineRate',
  AGENT_GROUP: 'agentGroupName',
  AGENT_SKILLS: 'agentSkills',
  ACTIVE: 'intenseConversations',
  MAX_OPEN: 'configuredMaxSlots',
  AGENT_PICTURE: 'agentPictureURL',
  NUM_AWAY_AGENTS: 'numAwayAgents',
  NUM_BACK_SOON_AGENTS: 'numBackSoonAgents',
  NUM_ONLINE_AGENTS: 'numOnlineAgents',
  // TODO:daniel from integration
  // OVERDUE_ASSIGNED: 'overdueAssigned',
  // OVERDUE_IN_QUEUE: 'overdueInQueue',
  OVERDUE_ASSIGNED: 'overdueConversationsAssigned',
  OVERDUE_IN_QUEUE: 'overdueConversationsInQueue',
  OVERDUE_UNASSIGNED: 'overdue_unassigned',
  OVERDUE_TOTAL: 'overdueConversationsTotal',
  CONVERSATION_IN_QUEUE_WAIT_TIME: 'waitTimeForAgentAssignment',
  AVG_WAIT_TIME: 'avgWaitTime',
  AVG_WAIT_TIME_FIRST_RESPONSE: 'avgWaitTimeFirstResponse',
  AVG_TIME_TO_RESPONSE: 'avgTimeToResponse',
  AVG_TIME_TO_FIRST_RESPONSE_FIRST_ASSIGNMENT: 'avgTimeToFirstResponseFirstAssignment',
  HUMAN_ONLINE_LOAD: 'humanOnlineLoad',
  HUMAN_AGENT_LOAD: 'humanAgentLoad',
  HUMAN_AWAY_LOAD: 'humanAwayLoad',
  IN_QUEUE_SKILL_NAME: 'skillName',
  // IN_QUEUE_UNASSIGNED_TOTAL is only in use for locating correct metric name
  // in defaultAccountSettings and is in use by WIDGET_ENABLING_OTHER_WIDGETS_METRICS constant.
  // It shouldn't be used anywhere else
  IN_QUEUE_UNASSIGNED_TOTAL: 'unassigned',
  IN_QUEUE_SKILL_WAIT_TIME: 'queueWaitTime90thPercentile',
  CONVERSATION_STATUS: 'status',
  VISITOR_NAME: 'visitorName',
  CONSUMER_ID: 'consumerId',
  CONVERSATION_ID: 'conversationId',
  CONVERSATION_SKILL: 'skill',
  CONVERSATION_START_TIME: 'startTimestamp',
  CONVERSATION_INTENTS: 'uniqueIntents',
  CONVERSATION_FIRST_INTENT: 'firstIntentLabel',
  NPS: 'nps',
  MCS: 'mcs',
  BRAND_NAME: 'brandName',
  SKILL_ASSIGNED_CONVERSATIONS: 'assignedConversations',
  SKILL_CLOSED_CONVERSATIONS: 'closedConversations',
  SKILL_LOAD: 'humanAgentLoad',
  SKILL_ONLINE_AGENTS: 'onlineAgents',
  SKILL_AWAY_AGENTS: 'awayAgents',
  SKILL_BACK_SOON_AGENTS: 'backSoonAgents',
  SKILL_WAIT_TIME_AGENT_ASSIGNMENT_50_PERCENTILE: 'queueWaitTime50thPercentile',
  SKILL_WAIT_TIME_AGENT_ASSIGNMENT_90_PERCENTILE: 'queueWaitTime90thPercentile',
  SKILL_OPEN_CONVERSATIONS: 'skillOpenConversations',
  SKILL_UNASSIGNED_CONVERSATIONS: 'unassignedConversations',
  SKILLS_SKILL_NAME: 'skillName',
  ACTIONABLE: 'actionableConversations',
  DIALOGS: 'dialogs',
  // SINGLE API
  AGENT_VIEW_AGENT_PICTURE: 'agentPictureURL',
  AGENT_VIEW_AGENT_NAME: 'agentName',
  AGENT_VIEW_AGENT_GROUP: 'agentGroupName',
  AGENT_VIEW_AGENT_STATUS: 'agentCurrentStatus',
  AGENT_VIEW_STATUS_REASON: 'agentCurrentStatusReason',
  AGENT_VIEW_STATUS_REASON_ID: 'agentCurrentStatusReasonId',
  AGENT_VIEW_AGENT_SKILLS: 'agentSkills',
  AGENT_VIEW_ASSIGNED_CONVERSATIONS: 'assignedConversations',
  AGENT_VIEW_CONCLUDED_CONVERSATIONS: 'concludedConversations',
  AGENT_VIEW_TRANSFER_RATE: 'transferRate',
  AGENT_VIEW_CLOSED_RATE: 'closedRate',
  AGENT_VIEW_PENDING_RATE: 'pendingAgentResponseRate',
  AGENT_VIEW_INTENTS_MATCHED_RATE: 'intentMatchedRate',
  AGENT_VIEW_METRICS_ONLINE_AGENTS: 'onlineAgents',
  AGENT_VIEW_METRICS_AWAY_AGENTS: 'awayAgents',
  AGENT_VIEW_METRICS_BACK_SOON_AGENTS: 'backSoonAgents',
  AGENT_VIEW_CSAT: 'csat',
  AGENT_VIEW_ACTIVE_CONVERSATIONS: 'activeConversations',
  AGENT_VIEW_MAX_SLOTS: 'maxSlots',
  AGENT_VIEW_AGENT_LOAD: 'agentLoad',
  AGENT_VIEW_CLOSED_CONVERSATIONS: 'closedConversations',
  AGENT_VIEW_AGENT_STATUS_DURATION: 'agentCurrentStatusStartTime',
  AGENT_VIEW_AGENT_STATUS_WITH_REASON_DURATION: 'agentCurrentStatusReasonStartTime',
  AGENT_VIEW_ONLINE_RATE: 'onlineRate',
  HISTORICAL_CONCLUDED_CONVERSATIONS: 'concludedConversations',
  HISTORICAL_TRANSFERS: 'transfers',
  HISTORICAL_CLOSED_CONVERSATIONS: 'closedConversations',
  CLOSED_BY_AGENT: 'closedByAgent',
  CLOSED_BY_CONSUMER: 'closedByConsumer',
  AUTO_CLOSED: 'autoClosed',
  AGENT_VIEW_AGENT_NOTIFICATIONS: 'notifications',
  AVG_CONVERSATIONS_DURATION: 'avgConversationsDuration',
  CLOSE_REASON: 'closeReason',
};

const METRIC_ID_TO_NAME = {
  agentStatus: METRIC_NAMES.AGENT_VIEW_AGENT_STATUS,
};

const WIDGET_NAMES_I18N_KEYS = {
  [WIDGET_LOGICAL_NAMES.IN_QUEUE]: 'queue_health_header',
  [WIDGET_LOGICAL_NAMES.SHIFT_STATUS]: 'shift_status_header',
  [WIDGET_LOGICAL_NAMES.AGENTS]: 'agents_list_header',
  [WIDGET_LOGICAL_NAMES.BOTS]: 'bots_list_header',
  [WIDGET_LOGICAL_NAMES.CONVERSATIONS]: 'conversations_header',
  [WIDGET_LOGICAL_NAMES.SKILLS]: 'skills_header',
};

const METRIC_NAMES_I18N_KEYS = {
  [METRIC_NAMES.CLOSED_CONVERSATIONS]: 'metric_closed_conversation',
  [METRIC_NAMES.ASSIGNED_CONVERSATIONS]: 'metric_assigned_conversation',
  [METRIC_NAMES.LOAD_CONVERSATIONS]: 'metric_load',
  [METRIC_NAMES.CSAT]: 'metric_csat',
  [METRIC_NAMES.AGENT_LOAD_CONVERSATIONS]: 'metric_load',
  [METRIC_NAMES.AGENT_VIEW_AGENT_STATUS]: 'metric_agent_status',
  [METRIC_NAMES.AGENT_VIEW_AGENT_STATUS_DURATION]: 'metric_agent_status_duration',
  [METRIC_NAMES.OVERDUE_ASSIGNED]: 'metric_overdue_assigned',
  [METRIC_NAMES.ACTIVE]: 'metric_active',
  [METRIC_NAMES.AVG_WAIT_TIME]: 'metric_avg_wait_time',
  [METRIC_NAMES.AVG_WAIT_TIME_FIRST_RESPONSE]: 'metric_avg_wait_time_first_response',
  [METRIC_NAMES.AVG_TIME_TO_RESPONSE]: 'metric_avg_time_to_response',
  [METRIC_NAMES.AVG_TIME_TO_FIRST_RESPONSE_FIRST_ASSIGNMENT]: 'metric_avg_time_to_first_response_first_assignment',
  [METRIC_NAMES.HUMAN_ONLINE_LOAD]: 'metric_humanOnlineLoad',
  [METRIC_NAMES.HUMAN_AWAY_LOAD]: 'metric_humanAwayLoad',
  [METRIC_NAMES.AGENT_VIEW_ASSIGNED_CONVERSATIONS]: 'metric_assigned_conversation',
  [METRIC_NAMES.AGENT_VIEW_INTENTS_MATCHED_RATE]: 'metric_conversation_intents',
  [METRIC_NAMES.AGENT_VIEW_TRANSFER_RATE]: 'metric_escalated',
  [METRIC_NAMES.AGENT_VIEW_PENDING_RATE]: 'metric_pending',
};

const METRIC_TYPE = {
  NONE: 'none',
  DURATION: 'duration',
  PERCENTAGE: 'percentage',
  ARRAY: 'array',
};

const METRIC_UNITS = {
  [METRIC_TYPE.NONE]: '',
  [METRIC_TYPE.PERCENTAGE]: '%',
};

const METRIC_UNIT_TYPE_MAP = {
  [METRIC_NAMES.ASSIGNED_CONVERSATIONS]: METRIC_TYPE.NONE,
  [METRIC_NAMES.LOAD_CONVERSATIONS]: METRIC_TYPE.PERCENTAGE,
  [METRIC_NAMES.AGENT_LOAD_CONVERSATIONS]: METRIC_TYPE.PERCENTAGE,
  [METRIC_NAMES.CSAT]: METRIC_TYPE.PERCENTAGE,
  // [METRIC_NAMES.RESPONSE_TIME]: METRIC_TYPE.DURATION,// Remove response time
  [METRIC_NAMES.CLOSED_CONVERSATIONS]: METRIC_TYPE.NONE,
  [METRIC_NAMES.AGENT_VIEW_AGENT_STATUS_DURATION]: METRIC_TYPE.DURATION,
  [METRIC_NAMES.AGENT_VIEW_STATUS_REASON]: METRIC_TYPE.NONE,
  [METRIC_NAMES.ONLINE_RATE]: METRIC_TYPE.PERCENTAGE,
  [METRIC_NAMES.AGENT_NAME]: METRIC_TYPE.NONE,
  [METRIC_NAMES.AGENT_GROUP]: METRIC_TYPE.NONE,
  [METRIC_NAMES.AGENT_SKILLS]: METRIC_TYPE.ARRAY,
  [METRIC_NAMES.ACTIVE]: METRIC_TYPE.NONE,
  [METRIC_NAMES.MAX_OPEN]: METRIC_TYPE.NONE,
  [METRIC_NAMES.AGENT_PICTURE]: METRIC_TYPE.NONE,
  [METRIC_NAMES.AVG_WAIT_TIME]: METRIC_TYPE.DURATION,
  [METRIC_NAMES.AVG_WAIT_TIME_FIRST_RESPONSE]: METRIC_TYPE.DURATION,
  [METRIC_NAMES.AVG_TIME_TO_RESPONSE]: METRIC_TYPE.DURATION,
  [METRIC_NAMES.AVG_TIME_TO_FIRST_RESPONSE_FIRST_ASSIGNMENT]: METRIC_TYPE.DURATION,
  [METRIC_NAMES.HUMAN_ONLINE_LOAD]: METRIC_TYPE.PERCENTAGE,
  [METRIC_NAMES.HUMAN_AWAY_LOAD]: METRIC_TYPE.PERCENTAGE,
  [METRIC_NAMES.AGENT_VIEW_ASSIGNED_CONVERSATIONS]: METRIC_TYPE.NONE,
  [METRIC_NAMES.AGENT_VIEW_AGENT_SKILLS]: METRIC_TYPE.ARRAY,
  [METRIC_NAMES.AGENT_VIEW_AGENT_NAME]: METRIC_TYPE.NONE,
  [METRIC_NAMES.AGENT_VIEW_AGENT_GROUP]: METRIC_TYPE.NONE,
  [METRIC_NAMES.AGENT_VIEW_CLOSED_RATE]: METRIC_TYPE.PERCENTAGE,
  [METRIC_NAMES.AGENT_VIEW_TRANSFER_RATE]: METRIC_TYPE.PERCENTAGE,
  [METRIC_NAMES.AGENT_VIEW_INTENTS_MATCHED_RATE]: METRIC_TYPE.PERCENTAGE,
  [METRIC_NAMES.AGENT_VIEW_PENDING_RATE]: METRIC_TYPE.PERCENTAGE,
  [METRIC_NAMES.AGENT_VIEW_AGENT_PICTURE]: METRIC_TYPE.NONE,
  [METRIC_NAMES.AGENT_VIEW_CSAT]: METRIC_TYPE.NONE,
  [METRIC_NAMES.AGENT_VIEW_ONLINE_RATE]: METRIC_TYPE.PERCENTAGE,
};

const DEFAULT_TIMEFRAME_RELATIVE_HOUR_VALUE = 1;
const DEFAULT_TIMEFRAME_ABSOLUTE_HOUR_VALUE = 0;

const UNASSIGNED_SKILL_ID = -1;

const MAIN_GROUP_ID = -1;

const DEFAULT_TIMEFRAME_DAYS_VALUE = 30;

const LOCAL_STORAGE_SETTINGS_PER_USER = userId => `le_amw_user_${userId}_settings`;

const LOCAL_STORAGE_ALERTS_PER_USER = userId => `le_amw_user_${userId}_alerts`;

const RESOURCES_CONFIGURATION_TIMEOUT = {
  AC: 30000,
  GENERAL_RESOURCE: 10000,
};

const RESOURCES_CONFIGURATION_INTERVAL = {
  AC: 60000,
  SEARCH_ENGAGEMENTS: 30000,
  GENERAL_RESOURCE: 10000,
};

const MAP_WIDGETS_NUMBER_OF_ROWS_PER_PAGE = {
  [WIDGET_LOGICAL_NAMES.CONVERSATIONS]: 50,
  [WIDGET_LOGICAL_NAMES.AGENTS]: 25,
  [WIDGET_LOGICAL_NAMES.SKILLS]: 25,
  [WIDGET_LOGICAL_NAMES.BOTS]: 25,
  [WIDGET_LOGICAL_NAMES.IN_QUEUE]: 50,
};

const SORT_DIRECTION = {
  ASCENDING: 'asc',
  DESCENDING: 'desc',
};

const MOMENT_LANGUAGE = {
  'da-DK': 'da', // Danish
  'de-DE': 'de', // German
  'en-US': 'en', // English
  'es-ES': 'es', // Spanish
  'fi-FI': 'fi', // Finnish
  'fr-FR': 'fr', // French
  'it-IT': 'it', // Italian
  'ja-JP': 'ja', // Japanese
  'ko-KR': 'ko', // Korean
  'pt-BR': 'pt-br', // Portuguese (Brazil)
  'ro-RO': 'ro', // Romanian,
  'ru-RU': 'ru', // Russian
  'tr-TR': 'tr', // Turkish
  'zh-CN': 'zh-cn', // Chinese (PRC)
};

const USAGE_MEASUREMENT_EVENTS = {
  MANAGERS_TAB_CLICKED: 'managersTabClicked',
  MANAGERS_TAB_ENTER: 'managersTabEnter',
  MANAGERS_TAB_LEAVE: 'managersTabLeave',
  MANAGERS_CONVERSATION_DRILL_DOWN: 'managersConversationDrillDown',
};

const USAGE_MEASUREMENT_ID = 'managerWorkspaceUsage';

const USER_TYPES = {
  SYSTEM: 0,
  HUMAN: 1,
  BOT: 2,
};

const STOP_SUBSCRIPTION_INTERVAL_SECONDS = 30;

const THEMES = {
  DARK: 'dark',
  LIGHT: 'light',
};

const DEFAULT_THEME = THEMES.DARK;

const PLACEHOLDER_PARAMS = {
  PRIMARY_COLOR: 'primaryColor',
  SECONDARY_COLOR: 'secondaryColor',
  SPEED: 'loaderSpeed',
};

const CHART_THEMES_PARAMS = {
  LEGEND_TEXT_COLOR: 'legendTextcolor',
  AXIS_LABEL_COLOR: 'axisLabelColor',
  AXIS_LINE_COLOR: 'axisLineColor',
  METRIC_COLORS: 'metricColors',
};

const PLACEHOLDER_SETTINGS = {
  [THEMES.DARK]: {
    [PLACEHOLDER_PARAMS.PRIMARY_COLOR]: '#273a66',
    [PLACEHOLDER_PARAMS.SECONDARY_COLOR]: '#758093',
    [PLACEHOLDER_PARAMS.SPEED]: 2,
  },
  [THEMES.LIGHT]: {
    [PLACEHOLDER_PARAMS.PRIMARY_COLOR]: '#c7d6e7',
    [PLACEHOLDER_PARAMS.SECONDARY_COLOR]: '#edf2f8',
    [PLACEHOLDER_PARAMS.SPEED]: 2,
  },
};

const GRAPH_THEMES_SETTINGS = {
  [THEMES.DARK]: {
    [CHART_THEMES_PARAMS.LEGEND_TEXT_COLOR]: '#fcfcfd',
    [CHART_THEMES_PARAMS.AXIS_LABEL_COLOR]: '#a7acbe',
    [CHART_THEMES_PARAMS.AXIS_LINE_COLOR]: '#fff',
    [CHART_THEMES_PARAMS.METRIC_COLORS]: [
      { color: '#FFF', areaColor: 'rgb(255, 255, 255, 0.1)' },
      { color: '#EF6161', areaColor: 'rgb(255, 0, 0, 0.1)' },
      { color: '#4B74FB', areaColor: 'rgb(0, 0, 255, 0.1)' },
    ],
  },
  [THEMES.LIGHT]: {
    [CHART_THEMES_PARAMS.LEGEND_TEXT_COLOR]: '#666666',
    [CHART_THEMES_PARAMS.AXIS_LABEL_COLOR]: '#888888',
    [CHART_THEMES_PARAMS.AXIS_LINE_COLOR]: '#888888',
    [CHART_THEMES_PARAMS.METRIC_COLORS]: [
      { color: '#B8BFD4', areaColor: 'rgb(184, 191, 212, 0.1)' },
      { color: '#EF6161', areaColor: 'rgb(255, 0, 0, 0.1)' },
      { color: '#4B74FB', areaColor: 'rgb(0, 0, 255, 0.1)' },
    ],
  },
};

const DEFAULT_TABLE_STYLE = {
  ROW_HEIGHT: 53,
  HEADER_HEIGHT: 31,
  HEADER_TITLE_FONT_SIZE_PX: 11,
  HEADER_FILTER_ICON_FONT_SIZE_PX: 11,
};

const TABLE_STYLE = {
  [WIDGET_LOGICAL_NAMES.IN_QUEUE]: {
    TABLE: {
      ROW_HEIGHT: 31,
      HEADER_HEIGHT: 31,
      HEADER_TITLE_FONT_SIZE_PX: 11,
      HEADER_FILTER_ICON_FONT_SIZE_PX: 11,
    },
  },
  [WIDGET_LOGICAL_NAMES.AGENTS]: {
    TABLE: DEFAULT_TABLE_STYLE,
  },
  [WIDGET_LOGICAL_NAMES.CONVERSATIONS]: {
    TABLE: DEFAULT_TABLE_STYLE,
  },
  [WIDGET_LOGICAL_NAMES.BOTS]: {
    TABLE: DEFAULT_TABLE_STYLE,
  },
  [WIDGET_LOGICAL_NAMES.SKILLS]: {
    TABLE: DEFAULT_TABLE_STYLE,
  },
};
const MAX_AMW_VERSION_NUMBER = 100000000;

const TIMEFRAME_FILTER_TYPES = {
  RELATIVE: 'relative',
  ABSOLUTE: 'absolute',
};

const WIDGET_DEFAULT_HEIGHT = 11.5;

const MAX_WIDGET_WIDTH = 12;

// Widgets which height is affected by varying amount of metrics
const WIDGET_NAMES_AFFECTED_BY_METRICS_AMOUNT =
  [WIDGET_LOGICAL_NAMES.SHIFT_STATUS, WIDGET_LOGICAL_NAMES.IN_QUEUE];

// Widgets to display on partial workspace view set
const WORKSPACE_PARTIAL_VIEW_WIDGETS =
  [WIDGET_LOGICAL_NAMES.AGENTS];

const NUMBER_OF_FILTER_MAX_ITEMS_CHARACTERS = 20;

const SHIFT_STATUS_ROW_METRICS_NUM_LIMIT = 4;

const QUEUE_HEALTH_METRIC_STATUS_ITEMS = {
  SKILLS_LIST: 'skillsList',
  IN_QUEUE_TOTAL: 'inQueueTotal',
  OVERDUE_TOTAL: 'overdueTotal',
};

const SUBSCRIPTION_STATUSES = {
  NONE: 'none',
  STARTED: 'started',
  STOPPED: 'stopped',
  STOPPING: 'stopping',
  STARTING: 'starting',
  ERROR: 'error',
};

const GRID_LAYOUT_GLOBAL_SETTINGS = {
  NUMBER_OF_COLUMNS: 12,
  ROW_HEIGHT: 30,
  MARGIN_TOP: 14,
  MARGIN_BOTTOM: 14,
  MIN_RESOLUTION_CLIENT_HEIGHT: 713, // the clientHeight for 1024x768 resolution
  MIN_RESOLUTION_TOTAL_GRID_ROWS: 14.85, // the number of grid rows for 1024x768 resolution
};

const PARTIAL_WIDGET_UNSUPPORTED_METRICS = {
  [WIDGET_LOGICAL_NAMES.AGENTS]: [METRIC_NAMES.AGENT_VIEW_CSAT],
};

const SOURCE_CONTEXT_NAMES = {
  ROOT: 'Root',
  [WIDGET_LOGICAL_NAMES.IN_QUEUE]: 'InQueue',
  [WIDGET_LOGICAL_NAMES.SHIFT_STATUS]: 'ActSum',
  [WIDGET_LOGICAL_NAMES.CONVERSATIONS]: 'Conver',
  [WIDGET_LOGICAL_NAMES.AGENTS]: 'Agents',
  [WIDGET_LOGICAL_NAMES.SKILLS]: 'Skills',
  [WIDGET_LOGICAL_NAMES.BOTS]: 'Bots',
};

const WIDGET_ENABLING_OTHER_WIDGETS_METRICS = {
  // temporarly removed until skills widget will be fully sortable
  // [WIDGET_LOGICAL_NAMES.SKILLS]: {
  //   [WIDGET_LOGICAL_NAMES.SHIFT_STATUS]:
  //     [METRIC_NAMES.IN_QUEUE_UNASSIGNED_TOTAL, METRIC_NAMES.OVERDUE_UNASSIGNED] },
};

const PRESETS = {
  DEFAULT_PRESET_NAME: 'Default',
  PRESETS_COUNT_LIMIT: 50,
};

const PRESET_VALIDATION_I18N_KEYS = {
  GLOBAL: {
    SKILLS: 'preset_validation_warning_global_skill',
    GROUPS: 'preset_validation_warning_global_groups',
  },
  AGENTS: {
    AGENTS_FILTER: 'preset_validation_warning_agents_agents_filter',
  },
  CONVERSATIONS: {
    AGENTS_FILTER: 'preset_validation_warning_conversations_agents_filter',
  },
  BOTS: {
    BOTS_FILTER: 'preset_validation_warning_bots_bots_filter',
  },
};

const MEMBER_TYPES = {
  AGENT: 'AGENT',
  USER: 'VISITOR',
};

const COLLAPSED_WIDGET_HEIGHT = 1.5;

const USER_TYPES_NAMES = {
  HUMAN: 'HUMAN',
  BOT: 'BOT',
};

const GRAPH_RESOLUTION = 12;

const ALERT_CONDITION_TYPES = {
  BELOW: 'below',
  ABOVE: 'above',
  BETWEEN: 'between',
};

const VALIDATION_TYPES = {
  NUMERIC: 'numeric',
  PERCENTAGE: 'percentage',
  DURATION: 'duration',
  TIMEFRAME: 'timeframe',
};

const DEFAULT_FIELD_MAX_LENGTH = 6;

const DURATION_TIME_UNITS = {
  HOURS: 'hours',
  MINUTES: 'minutes',
  SECONDS: 'seconds',
};

const DURATION_VALIDATION_TARGET = {
  VALUE: 'value',
  UNIT: 'unit',
};

const QUEUE_SUMMARY_SKILLS_ALERT_KEY = 'qs_skills_alert';

const MAP_ASSOCIATED_WIDGETS_COLLAPSE = {
  [WIDGET_LOGICAL_NAMES.IN_QUEUE]: [WIDGET_LOGICAL_NAMES.SHIFT_STATUS],
  [WIDGET_LOGICAL_NAMES.SHIFT_STATUS]: [WIDGET_LOGICAL_NAMES.IN_QUEUE],
};

const HIDDEN_WIDGET_TABS = [
  WIDGET_LOGICAL_NAMES.IN_QUEUE,
  WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
];

const WIDGETS_DISPLAY_ORDER = {
  [WIDGET_LOGICAL_NAMES.IN_QUEUE]: 1,
  [WIDGET_LOGICAL_NAMES.SHIFT_STATUS]: 2,
  [WIDGET_LOGICAL_NAMES.AGENTS]: 3,
  [WIDGET_LOGICAL_NAMES.BOTS]: 4,
  [WIDGET_LOGICAL_NAMES.SKILLS]: 5,
  [WIDGET_LOGICAL_NAMES.CONVERSATIONS]: 6,
};

const DASHBOARD_TAB_ID = 'dashboard';

const MAP_WIDGET_INITIAL_HEIGHT = {
  [WIDGET_LOGICAL_NAMES.IN_QUEUE]: WIDGET_DEFAULT_HEIGHT,
  [WIDGET_LOGICAL_NAMES.SHIFT_STATUS]: WIDGET_DEFAULT_HEIGHT,
  [WIDGET_LOGICAL_NAMES.AGENTS]: 8.2,
  [WIDGET_LOGICAL_NAMES.BOTS]: 8.2,
  [WIDGET_LOGICAL_NAMES.SKILLS]: 9.6,
  [WIDGET_LOGICAL_NAMES.CONVERSATIONS]: 9.6,
};

export {
  PRIVILEGES,
  SESSION_SETTINGS,
  DIALOG_TYPES,
  WIDGET_LOGICAL_NAMES,
  WIDGET_PERMISSIONS_MAP,
  RESTART_SUBSCRIPTION_STATUS_CODES,
  AXIOS_RETRY_OBJECT,
  RETRY_INTERVAL,
  RETRIES_MAX_NUMBER,
  UPDATE_SUBSCRIPTION_MODE,
  AGENT_STATUSES,
  CONVERSATION_STATUSES,
  CONVERSATION_QUEUE_STATES,
  CONVERSATION_STATUSES_I18N_KEYS,
  CONVERSATION_STATUSES_CLASSES_MAP,
  LOCAL_STORAGE_SETTINGS_PER_USER,
  RESOURCES_CONFIGURATION_TIMEOUT,
  RESOURCES_CONFIGURATION_INTERVAL,
  DATA_LOADING_STATES,
  WIDGET_MODES,
  DEFAULT_TIMEFRAME_RELATIVE_HOUR_VALUE,
  DEFAULT_TIMEFRAME_ABSOLUTE_HOUR_VALUE,
  DEFAULT_TIMEFRAME_DAYS_VALUE,
  METRIC_NAMES,
  METRIC_TYPE,
  METRIC_UNIT_TYPE_MAP,
  METRIC_UNITS,
  UNASSIGNED_SKILL_ID,
  MAIN_GROUP_ID,
  AGENT_STATUSES_LABELS_I18N_KEYS,
  SORT_DIRECTION,
  MOMENT_LANGUAGE,
  WIDGET_NAMES_I18N_KEYS,
  METRIC_NAMES_I18N_KEYS,
  PLACEHOLDER_SETTINGS,
  USAGE_MEASUREMENT_EVENTS,
  USAGE_MEASUREMENT_ID,
  USER_TYPES,
  STOP_SUBSCRIPTION_INTERVAL_SECONDS,
  THEMES,
  DEFAULT_THEME,
  MAX_AMW_VERSION_NUMBER,
  TIMEFRAME_FILTER_TYPES,
  TABLE_STYLE,
  NUMBER_OF_FILTER_MAX_ITEMS_CHARACTERS,
  MANAGER_WORKSPACE_SITE_SETTINGS_GROUP,
  QUEUE_HEALTH_METRIC_STATUS_ITEMS,
  SHIFT_STATUS_ROW_METRICS_NUM_LIMIT,
  SITE_SETTINGS_VERSION_KEY,
  WIDGET_NAMES_AFFECTED_BY_METRICS_AMOUNT,
  SUBSCRIPTION_STATUSES,
  AC_RETRY_AFTER_ERROR_INTERVAL,
  FEATURES,
  WORKSPACE_PARTIAL_VIEW_WIDGETS,
  GRID_LAYOUT_GLOBAL_SETTINGS,
  PARTIAL_WIDGET_UNSUPPORTED_METRICS,
  SOURCE_CONTEXT_NAMES,
  THROTTLING_STATUS_CODE,
  WIDGET_FEATURES_MAP,
  MAX_WIDGET_WIDTH,
  WIDGET_ENABLING_OTHER_WIDGETS_METRICS,
  MAP_WIDGETS_NUMBER_OF_ROWS_PER_PAGE,
  PRESETS,
  MEMBER_TYPES,
  USER_TYPES_NAMES,
  GRAPH_THEMES_SETTINGS,
  CHART_THEMES_PARAMS,
  GRAPH_RESOLUTION,
  PRESET_VALIDATION_I18N_KEYS,
  ALERT_CONDITION_TYPES,
  VALIDATION_TYPES,
  DEFAULT_FIELD_MAX_LENGTH,
  LOCAL_STORAGE_ALERTS_PER_USER,
  DURATION_TIME_UNITS,
  DURATION_VALIDATION_TARGET,
  QUEUE_SUMMARY_SKILLS_ALERT_KEY,
  METRIC_ID_TO_NAME,
  COLLAPSED_WIDGET_HEIGHT,
  MAP_ASSOCIATED_WIDGETS_COLLAPSE,
  HIDDEN_WIDGET_TABS,
  DASHBOARD_TAB_ID,
  WIDGETS_DISPLAY_ORDER,
  MAP_WIDGET_INITIAL_HEIGHT,
  WIDGET_DEFAULT_HEIGHT,
};
